import { css } from "@emotion/css";
import { useContext } from "react";
import { Button } from "react-aria-components";

import { AccordionContext } from "./Accordion";
import { useColors } from "../../hooks/useColors";
import { useGetAllFocusShadows } from "../utils";

export interface AccordionToggleProps {
  children: React.ReactNode;
  className?: string;
}

export function AccordionToggle(props: AccordionToggleProps) {
  const { className } = props;
  const { isOpen, setIsOpen } = useContext(AccordionContext);
  const colors = useColors();
  const boxShadow = `inset 0 0 0 1px ${colors["border-button"]}`;
  const getAllFocusShadows = useGetAllFocusShadows();

  return (
    <Button
      onPress={() => setIsOpen(!isOpen)}
      className={css(
        {
          all: "unset",
          cursor: "pointer",
          width: "100%",
          overflow: "hidden",
          "&[data-focused]": getAllFocusShadows(boxShadow),
        },
        className
      )}
    >
      {props.children}
    </Button>
  );
}
